export default __webpack_public_path__ + "static/logo5-e132c489201d5e4ee2e84f5053f363dc.webp";